import { createContext, useContext, useMemo, useState } from 'react';
import dayjs from 'dayjs';

const FiltersContext = createContext(null);

export function FiltersProvider({ children }) {
  const [fuel, setFuel] = useState('BENZINA');
  const [service, setService] = useState('self');
  const [territory, setTerritory] = useState({ type: 'country', code: 'IT', name: 'Italia' });
  const [from, setFrom] = useState(dayjs().subtract(12, 'month').format('YYYY-MM-DD'));
  const [to, setTo] = useState(dayjs().format('YYYY-MM-DD'));

  const value = useMemo(() => ({
    fuel, setFuel, service, setService, territory, setTerritory, from, setFrom, to, setTo,
  }), [fuel, service, territory, from, to]);

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
}

export function useFilters() {
  const context = useContext(FiltersContext);
  if (!context) throw new Error('useFilters deve essere usato dentro FiltersProvider');
  return context;
}
